//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ColFilter from "@/components/FilterTable/ColFilter.vue";

export default {
  name: "TraitsTable",
  props: ["tableClass", "bordered", "value"],
  components: {
    ColFilter,
  },
  mounted: () => {},
  data: () => ({
    separator: "horizontal",
    priceHistory: [1, 5, 4, 7, 8, 6, 85, 43, 72],
    carouselPagination: 2,
    pagination: {
      rowsPerPage: 30, // current rows per page being displayed
    },
    slide: 1,
    columns: [
      {
        name: "start-date",
        required: true,
        label: "Data Início",
        align: "left",
        field: (row) => (row.start_date ? row.start_date : "N/A"),
        sortable: true,
      },
      {
        name: "end-date",
        required: true,
        label: "Data Fim",
        align: "left",
        field: (row) => (row.end_date ? row.end_date : "N/A"),
        sortable: true,
      },
      {
        name: "insignia",
        align: "left",
        label: "Insignia",
        field: (row) => (row.insignia ? row.insignia.name : "N/A"),
        sortable: true,
      },
      {
        name: "price",
        align: "left",
        label: "Preço",
        field: (row) => (row.price ? `${row.price} €` : "N/A"),
        sortable: true,
      },
    ],
  }),
  methods: {
    fetchRowData: function (index) {
      let data = this.data[index];
      this.$emit("clicked-row", data);
    },
    updateData: function () {
      this.$emit("value", this.value);
    },
  },
  computed: {
    recentPrices: function () {
      return this.value.product_prices.filter((i) => !i.end_date);
    },
    pricesCarousel: function () {
      return Array.from(
        {
          length: Math.ceil(this.recentPrices.length / this.carouselPagination),
        },
        (v, i) =>
          this.recentPrices.slice(
            i * this.carouselPagination,
            i * this.carouselPagination + this.carouselPagination
          )
      );
    },
  },
};
